import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Tests from './pages/Tests';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import Studies from './pages/Studies';
import StudyDetail from './pages/StudyDetail';
import PatientsExpanded from './pages/PatientsExpanded';
import PatientForm from './pages/PatientForm';
import Billing from './pages/Billing';
import NursingPanel from './pages/NursingPanel';
import LabPanel from './pages/LabPanel';
import SamplesHub from './pages/SamplesHub';
import StudyReports from './pages/StudyReports';
import Catalogs from './pages/Catalogs';
import ClinicalNotesPage from './pages/ClinicalNotesPage';

function App() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/patients" element={<PatientsExpanded />} />
                <Route path="/patients/new" element={<PatientForm />} />
                <Route path="/studies" element={<Studies />} />
                <Route path="/studies/:id" element={<StudyDetail />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/samples" element={<SamplesHub />} />
                <Route path="/nursing" element={<NursingPanel />} />
                <Route path="/laboratory" element={<LabPanel />} />
                <Route path="/reports/studies" element={<StudyReports />} />
                <Route path="/catalogs" element={<Catalogs />} />
                <Route path="/patients/:id/clinical-notes" element={<ClinicalNotesPage />} />

                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="nosotros" element={<About />} />
                    <Route path="servicios" element={<Services />} />
                    <Route path="pruebas" element={<Tests />} />
                    <Route path="blog" element={<Blog />} />
                    <Route path="blog/:slug" element={<BlogPost />} />
                    <Route path="contacto" element={<Contact />} />
                    <Route path="privacidad" element={<Privacy />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
